import actions from "./actions";

export default {
  namespaced: true,
  state: {
    comment: null,
    comments: [],
    topLikes: [],
    topComments: [],
    userTopics: [],
    users: [],
    count: 0
  },
  mutations: {
    setComment(state, comment) {
      state.comment = comment;
    },
    setComments(state, comments) {
      state.comments = comments;
    },
    setComments(state, comments) {
      state.comments = comments;
    },
    addComments(state, comments) {
      state.comments = [...state.comments, ...comments];
    },
    setTopLikes(state, topLikes) {
      state.topLikes = topLikes;
    },
    setTopComments(state, topComments) {
      state.topComments = topComments;
    },
    setUserTopics(state, userTopics) {
      state.userTopics = userTopics;
    },
    setUsers(state, users) {
      state.users = users;
    },
    setCount(state, count) {
      state.count = count;
    }
  },
  actions
};
